export default {
  articleManagement: {
    taggingStatus: {
      filterLabel: 'Trạng thái gắn thẻ',
      filterPlaceholder: 'Chọn trạng thái gắn thẻ',
      colTitle: 'Thẻ / Gắn thẻ',
      editAction: 'Sửa thẻ',
      pending: 'Chờ gắn thẻ',
      tagged: 'Đã gắn thẻ',
      toBeTagged: 'Cần gắn lại',
    },
    tagEdit: {
      title: 'Sửa thẻ bài viết',
      placeholder: 'Chọn 2-4 thẻ đang bật',
      countHint: 'Khuyến nghị: {min}-{max} thẻ (đã chọn {count})',
      saveOk: 'Đã lưu thẻ',
      loadTagsFail: 'Tải từ điển thẻ thất bại',
      loadCurrentFail: 'Tải thẻ hiện tại thất bại, vui lòng chọn lại',
    },
      aiReworkBtn: "Viết lại bằng AI",
      submitOnlyDraft: "Chỉ bài viết nháp mới có thể gửi duyệt",
    title: 'Quản lý bài viết',
    addNew: 'Bài viết mới',
    createTitle: 'Bài viết mới',
    editTitle: 'Chỉnh sửa bài viết',
    batchDelete: 'Xóa hàng loạt',
    batchUpdateStatus: 'Cập nhật trạng thái hàng loạt',
    batchAssignAuthor: 'Phân công tác giả hàng loạt',
    confirmBatchDelete: 'Bạn có chắc muốn xóa các bài viết đã chọn?',
    selectRows: 'Vui lòng chọn bài viết trước',
    status: {
      draft: 'Bản nháp',
      pending: 'Chờ duyệt',
      pendingReview: 'Chờ duyệt',
      published: 'Đã xuất bản',
      rejected: 'Bị từ chối',
      offline: 'Đã hạ xuống',
    },
    source: {
      manual: 'Thủ công',
      ai: 'AI tạo',
    },
    scoreLevel: {
      excellent: 'Xuất sắc',
      good: 'Tốt',
      warning: 'Cần cải thiện',
      fail: 'Không đạt',
    },
    stats: {
      total: 'Tổng',
      draft: 'Bản nháp',
      pending: 'Chờ duyệt',
      published: 'Đã xuất bản',
      rejected: 'Bị từ chối',
      offline: 'Đã hạ',
    },
    actions: {
      viewLive: 'Xem trang',
      edit: 'Chỉnh sửa',
      aiRewrite: '🤖 Viết lại AI',
      preview: 'Xem trước',
      score: 'Đánh giá',
      reScore: 'Chấm điểm lại',
      submitReview: 'Gửi duyệt',
      resubmit: 'Gửi lại',
      review: 'Xét duyệt',
      approve: 'Phê duyệt',
      reject: 'Từ chối',
      offline: 'Hạ xuống',
      delete: 'Xóa',
      returnToDraft: 'Trả về nháp',
      confirmOffline: 'Bạn có chắc muốn hạ bài viết này?',
      confirmDelete: 'Bạn có chắc muốn xóa bài viết này?',
      scoreHint: 'Điểm SEO/GEO phải ≥ 70 để gửi duyệt',
      submitReviewIllegal: 'Trạng thái bài viết không cho phép gửi duyệt — vui lòng đảm bảo bài viết ở trạng thái nháp',
    },
    form: {
      keyword: 'Tiêu đề bài viết',
      keywordPlaceholder: 'Tìm tiêu đề',
      language: 'Ngôn ngữ',
      languagePlaceholder: 'Chọn ngôn ngữ',
      category: 'Danh mục',
      categoryPlaceholder: 'Chọn danh mục',
      status: 'Trạng thái',
      statusPlaceholder: 'Chọn trạng thái',
      source: 'Nguồn',
      sourcePlaceholder: 'Chọn nguồn',
      author: 'Tác giả',
      authorPlaceholder: 'Chọn tác giả',
      authorFilter: 'Tác giả',
      authorFilterPlaceholder: 'Tìm tên tác giả',
      scoreMin: 'Điểm tối thiểu',
      scoreMax: 'Điểm tối đa',
      scoreRange: 'Khoảng điểm',
      dateRange: 'Thời gian cập nhật',
      startDate: 'Ngày bắt đầu',
      endDate: 'Ngày kết thúc',
      title: 'Tiêu đề',
      titlePlaceholder: 'Nhập tiêu đề bài viết',
      titleRequired: 'Vui lòng nhập tiêu đề bài viết',
      slug: 'Slug',
      slugPlaceholder: 'Tự động tạo, có thể chỉnh sửa',
      tags: 'Thẻ',
      tagsPlaceholder: 'Phân cách bằng dấu phẩy',
      articleSource: 'Nguồn bài viết',
      sourceManual: 'Viết thủ công',
      sourceAI: 'Tạo bằng AI →',
      sourceAIHint: 'Chuyển đến trình tạo nội dung AI.',
      scheduledPublish: 'Lên lịch xuất bản',
      scheduledTime: 'Thời gian xuất bản',
      scheduledTimePlaceholder: 'Chọn thời gian xuất bản',
      summary: 'Tóm tắt',
      summaryPlaceholder: 'Nhập tóm tắt bài viết',
      content: 'Nội dung',
      coverImage: 'Ảnh bìa',
      coverImageHint: 'Ảnh bìa cũng được dùng làm OG Image',
      keywords: 'Từ khóa liên quan',
      keywordsPlaceholder: 'Tìm và chọn từ khóa',
      relatedKeywordsHint: 'Từ khóa đầu tiên là chính, còn lại là phụ',
      keywordFilter: 'Từ khóa mục tiêu',
      keywordFilterPlaceholder: 'Lọc bài theo từ khóa',
      secondaryKeywords: 'Từ khóa phụ',
      secondaryKeywordsPlaceholder: 'Chọn từ khóa phụ (nhiều)',
      rejectReason: 'Lý do từ chối',
      rejectReasonPlaceholder: 'Nhập lý do từ chối',
      rejectReasonRequired: 'Vui lòng nhập lý do từ chối',
      seoTitle: 'Tiêu đề SEO',
      seoTitlePlaceholder: 'Khuyến nghị 50-60 ký tự',
      seoTitleCount: '{count} ký tự',
      seoTitleWarn: 'Khuyến nghị 50-60 ký tự',
      seoDescription: 'Meta Description',
      seoDescriptionPlaceholder: 'Khuyến nghị 100-160 ký tự',
      seoDescCount: '{count} ký tự',
      seoDescWarn: 'Khuyến nghị 100-160 ký tự',
      canonical: 'Canonical URL',
      canonicalPlaceholder: 'URL chuẩn',
      metaRobots: 'Meta Robots',
      ogImage: 'OG Image',
      assignAuthor: 'Phân công tác giả',
      assignAuthorPlaceholder: 'Chọn tác giả',
      targetStatus: 'Trạng thái mục tiêu',
      articleType: 'Loại bài viết',
      articleTypeRequired: 'Vui lòng chọn loại bài viết',
      articleTypePlaceholder: 'Chọn loại bài viết',
      languageRequired: 'Vui lòng chọn ngôn ngữ',
      slugRequired: 'Vui lòng nhập URL Slug',
      authorRequired: 'Vui lòng chọn tác giả',
      seoTitleRequired: 'Vui lòng nhập SEO Title',
      seoDescRequired: 'Vui lòng nhập Meta Description',
      ogTitle: 'OG Title',
      ogTitlePlaceholder: 'OG Title',
      ogDescription: 'OG Description',
      ogDescriptionPlaceholder: 'OG Description',
    },
    serp: {
      title: 'Xem trước SERP Google',
      urlExample: 'https://yoursite.com/article',
    },
    review: {
      title: 'Xét duyệt bài viết',
      info: 'Thông tin bài viết',
      seoScore: 'Điểm SEO/GEO',
      checkItems: 'Danh sách kiểm tra',
      submitInfo: 'Thông tin gửi',
      submittedBy: 'Người gửi',
      submittedAt: 'Thời gian gửi',
      seoInfo: 'Thông tin SEO',
      keywords: 'Từ khóa mục tiêu',
      wordCount: 'Số từ',
      chars: 'ký tự',
      comment: 'Nhận xét',
      commentPlaceholder: 'Nhập nhận xét (bắt buộc khi từ chối)',
      commentRequired: 'Vui lòng nhập nhận xét khi từ chối',
      btnReturnToDraft: 'Trả về nháp',
      btnReject: 'Từ chối',
      btnApprove: 'Phê duyệt & Xuất bản',
      approveSuccess: 'Bài viết đã được phê duyệt và xuất bản',
      rejectSuccess: 'Bài viết đã bị từ chối',
      confirmText: 'Bạn có chắc chắn muốn phê duyệt và xuất bản bài viết này không?',
      returnSuccess: 'Đã trả về nháp',
      checkHasTitle: 'Có tiêu đề',
      checkHasSlug: 'Có slug',
      checkHasSeoTitle: 'Có tiêu đề SEO',
      checkHasSeoDesc: 'Có meta description',
      checkHasCover: 'Có ảnh bìa',
      checkHasAuthor: 'Có tác giả',
      checkScorePass: 'Điểm SEO ≥ 80',
      pass: 'Đạt',
      warn: 'Cảnh báo',
      fail: 'Không đạt',
    },
    batchAuthor: {
      title: 'Phân công tác giả hàng loạt',
      label: 'Tác giả',
      required: 'Vui lòng chọn tác giả',
      success: 'Phân công tác giả thành công',
      apiFail: 'Gọi API phân công tác giả hàng loạt thất bại. Vui lòng liên hệ backend để xác nhận endpoint đã sẵn sàng.',
    },
    batchDeleteApiFail: 'Gọi API xóa hàng loạt thất bại. Vui lòng liên hệ backend để xác nhận endpoint đã sẵn sàng.',
    batchUpdateStatusApiFail: 'Gọi API cập nhật trạng thái hàng loạt thất bại. Vui lòng liên hệ backend để xác nhận endpoint đã sẵn sàng.',
    loadDetailFailed: 'Tải chi tiết bài viết thất bại. Vui lòng đóng và thử lại để tránh ghi đè nội dung gốc.',
    table: {
      cover: 'Ảnh bìa',
      title: 'Tiêu đề',
      category: 'Danh mục',
      keywords: 'Từ khóa mục tiêu',
      author: 'Tác giả',
      seoScore: 'SEO',
      geoScore: 'GEO',
      totalScore: 'Điểm tổng hợp',
      source: 'Nguồn',
      status: 'Trạng thái',
      updateTime: 'Cập nhật',
      action: 'Thao tác',
    },
    tabs: {
      basic: 'Thông tin cơ bản',
      seo: 'Cài đặt SEO',
    },
    saveDraft: 'Lưu nháp',
    keywordRelSaveWarn: 'Đã lưu bài viết, nhưng lưu liên kết từ khóa thất bại — vui lòng thử lại',
    inlinkBtn: 'Liên kết nội bộ',
    inlinkModalTitle: 'Đề xuất liên kết nội bộ',
    inlinkInjectBtn: 'Chèn liên kết ({n})',
    inlinkInjectOk: 'Đã chèn {n} liên kết nội bộ vào nội dung. Nhấn "Xác nhận" để lưu bài viết.',
    inlinkEmpty: 'Không tìm thấy liên kết phù hợp',
    inlinkHint: 'Liên kết được chọn sẽ chèn tại vị trí xuất hiện đầu tiên của anchor text trong nội dung (không tính tiêu đề). Sau đó nhấn "Xác nhận" để lưu bài viết, nếu không liên kết sẽ mất.',
    inlinkNoneInsertable: 'Không có liên kết nào để chèn: đã có liên kết hoặc anchor text không xuất hiện trong nội dung',
    inlinkStatusLinked: 'Đã chèn',
    inlinkStatusMissing: 'Anchor text không có trong nội dung',
    inlinkStatusSelf: 'Trỏ về bài viết hiện tại',
    inlinkReasonLinked: 'Nội dung đã có liên kết tới {url}, không cần chèn lại',
    inlinkReasonMissing: 'Anchor text "{anchor}" không xuất hiện trong nội dung nên không xác định được vị trí chèn. Hãy thêm cụm từ này vào nội dung rồi mở lại đề xuất, hoặc thêm liên kết thủ công trong trình soạn thảo',
    inlinkReasonNoTarget: 'Ứng viên này không có URL đích, không thể chèn',
    inlinkReasonSelf: 'Đích là chính bài viết này, không chèn liên kết tự trỏ',
    inlinkUnsavedTip: 'Liên kết nội bộ đã được chèn nhưng chưa lưu. Nhấn "Xác nhận" để lưu bài viết; đóng mà không lưu sẽ mất các liên kết này.',
    inlinkUnsavedConfirmTitle: 'Liên kết nội bộ chưa được lưu',
    inlinkUnsavedConfirmOk: 'Bỏ và đóng',
    inlinkUnsavedConfirmBack: 'Quay lại lưu',
    viewJsonLdBtn: 'JSON-LD',
    jsonLdModalTitle: 'Xem trước JSON-LD (chỉ đọc)',
    previewBtn: 'Xem trước',
    scoreBtn: 'Đánh giá trước',
    submitReviewBtn: 'Gửi duyệt',
    scoreGateTooltip: 'Điểm SEO phải ≥ 80 để gửi duyệt (hiện tại: {score})',
    openLiveTitle: 'Mở trang H5',
    openAuthorTitle: 'Mở trang tác giả (H5)',
    kwFilterBanner: 'Đang lọc theo từ khóa liên quan: ',
    kwFilterClear: 'Xóa bộ lọc',
    liveBaseUrlMissing: 'Chưa cấu hình tên miền (h5BaseUrl); không thể mở trang trực tuyến',
    liveUnavailable: 'Chưa đăng — không có trang live',
    unsignedAuthor: 'Chưa có tác giả',
  },

  articleTag: {
    addBtn: 'Thêm thẻ',
    backfillBtn: 'Gắn thẻ tồn đọng',
    listTitle: 'Từ điển thẻ',
    frm: {
      tagName: 'Tên thẻ',
      tagNamePlaceholder: 'Tìm tên thẻ',
      status: 'Trạng thái',
      statusAll: 'Tất cả',
    },
    status: {
      enabled: 'Bật',
      disabled: 'Tắt',
    },
    col: {
      tagName: 'Tên thẻ',
      status: 'Trạng thái',
      usageCount: 'Số bài tham chiếu',
      createUser: 'Người tạo',
      updateTime: 'Cập nhật lúc',
      action: 'Thao tác',
    },
    deleteConfirmTitle: 'Xóa thẻ',
    deleteConfirmContent: 'Xóa thẻ "{name}"?',
    deleteInUse: 'Thẻ đang được bài viết tham chiếu, không thể xóa',
    deleteDisabledTip: 'Không thể xóa khi số bài tham chiếu > 0',
    edit: {
      createTitle: 'Thêm thẻ',
      editTitle: 'Sửa thẻ',
      tagName: 'Tên thẻ',
      tagNamePlaceholder: 'Nhập tên thẻ',
      tagNameRequired: 'Vui lòng nhập tên thẻ',
      status: 'Trạng thái',
      createOk: 'Đã tạo thẻ',
      saveOk: 'Đã lưu thẻ',
      duplicate: 'Tên thẻ đã tồn tại',
    },
    config: {
      title: 'Cấu hình mô hình gắn thẻ',
      model: 'Mô hình gắn thẻ',
      modelPlaceholder: 'Chọn mô hình',
      modelRequired: 'Vui lòng chọn mô hình gắn thẻ',
      modelLoadFail: 'Tải danh sách mô hình thất bại; hãy đảm bảo dịch vụ mô hình gắn thẻ đã triển khai',
      autoTagging: 'Bật gắn thẻ tự động',
      saveOk: 'Đã lưu cấu hình',
    },
    backfill: {
      title: 'Gắn thẻ tồn đọng',
      mode: 'Cách thức',
      manual: 'Thủ công từng bài',
      batch: 'Tác vụ hàng loạt',
      scope: 'Phạm vi',
      scopeToTag: 'Chỉ chờ gắn thẻ',
      scopeAllPublished: 'Tất cả đã đăng',
      batchSize: 'Số lượng mỗi lô',
      limit: 'Giới hạn số lượng',
      limitExtra: 'Chỉ gắn thẻ bài đã đăng & chưa gắn thẻ, mặc định 200',
      gotoManual: 'Đến Quản lý bài viết',
      runBatch: 'Chạy gắn thẻ',
      batchOk: 'Đã kích hoạt tác vụ gắn thẻ',
    },
  },

  articleType: {
    title: 'Quản lý danh mục bài viết',
    addNew: 'Danh mục mới',
    createTitle: 'Danh mục mới',
    editTitle: 'Chỉnh sửa danh mục',
    seoEditTitle: 'Cấu hình mẫu SEO',
    saveAndSeo: 'Lưu & Cấu hình SEO',
    seoConfig: 'Cấu hình SEO',
    seoConfigured: 'Đã cấu hình',
    seoNotConfigured: 'Chưa cấu hình',
    tplVarHint: 'Biến mẫu: {categoryName} {total} {currentYear} {latestUpdate}',
    actions: {
      edit: 'Chỉnh sửa',
      seo: 'Mẫu SEO',
      delete: 'Xóa',
      confirmDelete: 'Bạn có chắc muốn xóa danh mục này?',
        confirmDeleteName: 'Bạn có chắc muốn xóa danh mục "{name}" không?',
},
    form: {
      keyword: 'Tên danh mục',
      keywordPlaceholder: 'Tìm tên danh mục',
      language: 'Ngôn ngữ',
      languagePlaceholder: 'Chọn ngôn ngữ',
      isActive: 'Trạng thái',
      isActivePlaceholder: 'Chọn trạng thái',
      seoConfigured: 'Cấu hình SEO',
      sortBy: 'Sắp xếp',
      sortByManual: 'Thủ công',
      sortByArticleCount: 'Bài viết giảm dần',
      sortByUpdateTime: 'Cập nhật gần đây',
      languageRequired: 'Vui lòng chọn ngôn ngữ',
      parent: 'Danh mục cha',
      parentPlaceholder: 'Chọn danh mục cha (tùy chọn)',
      name: 'Tên danh mục',
      namePlaceholder: 'Nhập tên danh mục',
      nameRequired: 'Vui lòng nhập tên danh mục',
      slug: 'Slug',
      slugPlaceholder: 'Định danh duy nhất, đường dẫn URL',
      slugFormat: 'Slug chỉ cho phép chữ thường, số và dấu gạch ngang',
      seoKeywords: 'Meta Keywords',
      seoKeywordsPlaceholder: 'Phân tách bằng dấu phẩy (Google bỏ qua; tùy chọn)',
      slugRequired: 'Vui lòng nhập slug',
      description: 'Mô tả',
      descriptionPlaceholder: 'Nhập mô tả danh mục',
      descPlaceholder: 'Nhập mô tả danh mục (tùy chọn)',
      sortOrder: 'Thứ tự sắp xếp',
      sortOrderPlaceholder: 'Số nhỏ hơn = vị trí cao hơn',
      seoTitleTpl: 'Mẫu tiêu đề SEO',
      seoTitleTplPlaceholder: 'vd: Hướng dẫn {categoryName} {currentYear} | {total} bài viết',
      seoDescTpl: 'Mẫu Meta Description',
      seoDescTplPlaceholder: 'vd: Khám phá {total} bài viết {categoryName}, cập nhật {latestUpdate}',
      schemaType: 'Loại Schema',
      schemaTypePlaceholder: 'Chọn loại Schema',
      hreflangList: 'Liên kết Hreflang',
      hreflangListPlaceholder: 'vd: en-US:/en/category/xxx,vi-VN:/vi/category/xxx',
    },
    table: {
      name: 'Tên danh mục',
      language: 'Ngôn ngữ',
      articleCount: 'Bài viết',
      seoTemplate: 'Mẫu SEO',
      sortOrder: 'Thứ tự',
      isActive: 'Trạng thái',
      updateTime: 'Cập nhật',
      action: 'Thao tác',
    },
    stats: {
      total: 'Tổng danh mục',
      languages: 'Ngôn ngữ',
      articles: 'Tổng bài viết',
      seoRate: 'Tỷ lệ SEO',
      languageUnit: 'ngôn ngữ',
      articleUnit: 'bài',
      balance: 'Cân bằng nền tảng',
      balanceTip: 'Danh mục hoạt động có bài viết / Tổng danh mục',
    },
    tabs: {
      basic: 'Thông tin cơ bản',
      seoTemplate: 'Mẫu SEO',
    },
    schema: {
      collectionPage: 'CollectionPage',
      itemList: 'ItemList',
    },
    seo: {
      metaDescPreviewPlaceholder: 'Meta description sẽ hiển thị ở đây…',
      serpPreview: 'Xem trước SERP',
    },
  },

  keyWordCenter: {
    importSuccess: "Nhap thanh cong {success}, that bai {fail}",
    importEmpty: "Khong phat hien du lieu hop le",
    importLangMismatch: "dòng có ý định/ưu tiên/ngôn ngữ không nhận dạng — CSV có thể xuất ở ngôn ngữ khác; hãy chuyển sang ngôn ngữ đó và thử lại",
    exportEmpty: "Khong co du lieu theo bo loc hien tai",
    exportSuccess: "Da xuat {count} tu khoa",
    title: 'Trung tâm từ khóa',
    addNew: 'Thêm từ khóa',
    createTitle: 'Thêm từ khóa',
    editTitle: 'Chỉnh sửa từ khóa',
    batchImport: 'Nhập hàng loạt',
    batchDelete: 'Xóa hàng loạt',
    confirmBatchDelete: 'Bạn có chắc muốn xóa các từ khóa đã chọn?',
    selectRows: 'Vui lòng chọn từ khóa trước',
    importTitle: 'Nhập từ khóa hàng loạt',
    importHint: 'Mỗi dòng một từ khóa, định dạng: từ khóa | ý định | ngôn ngữ | ưu tiên | lượng tìm kiếm',
    importPlaceholder: 'từ khóa | ý định | ngôn ngữ | ưu tiên | lượng tìm kiếm\ncasino trực tuyến | transactional | vi-VN | high | 12400',
    importFormatHint: 'Hỗ trợ dấu phẩy, ống hoặc tab. Cũng có thể tải lên CSV đã xuất (tự nhận diện tiêu đề; bỏ qua các cột trạng thái / số bài đã tạo / thời gian cập nhật). Từ khóa đã tồn tại sẽ tự động bỏ qua.',
    intent: {
        informational: 'Thông tin', info: 'Thông tin',
        navigational: 'Điều hướng', nav: 'Điều hướng',
        transactional: 'Giao dịch', trans: 'Giao dịch',
        commercial: 'Thương mại', comm: 'Thương mại',
      },
    confirmStatus: {
      PENDING: 'Chờ xác nhận',
      CONFIRMED: 'Đã xác nhận',
      REJECTED: 'Đã từ chối',
    },
    volumeSource: {
      gsc: 'GSC',
      dataforseo: 'DataForSEO',
      manual: 'Thủ công',
      unknown: 'Không rõ',
    },
    volumeSourceGscNote: 'lượt hiển thị',
    volumeStale: 'cũ',
    generate: {
      disabledNotConfirmed: 'Hãy xác nhận ý định trước khi tạo bài viết',
      disabledIsTypo: 'Từ khóa sai chính tả — hãy dùng Gộp thay vì tạo bài',
      disabledIsNav: 'Từ khóa điều hướng trỏ đến trang chức năng — không tạo bài viết',
    },
    confirmIntentTitle: 'Xác nhận ý định',
    confirmIntentDesc: 'Xác nhận ý định tìm kiếm cho từ khóa sau:',
    confirmIntentSuccess: 'Đã xác nhận ý định',
    confirmNoEffect: 'Chưa có thay đổi: từ khóa có thể đã được xác nhận/từ chối hoặc không qua kiểm tra backend; làm mới và thử lại',
    merge: {
      title: 'Gộp từ khóa sai chính tả',
      targetKeyword: 'dataPkCode từ khóa đích',
      targetPageUrl: 'URL trang đích',
      success: 'Đã gộp',
    },
    priority: {
        high: 'Cao',
        medium: 'Trung bình',
        low: 'Thấp',
      },
    // Từ điển ý định backend intentCode → nhãn hiển thị đa ngôn ngữ (chỉ để hiển thị; vẫn gửi intentCode cho backend)
    intentByCode: {
      informational: 'Thông tin', info: 'Thông tin',
      navigational: 'Điều hướng', nav: 'Điều hướng',
      transactional: 'Giao dịch', trans: 'Giao dịch',
      commercial: 'Thương mại', comm: 'Thương mại',
      comparison: 'So sánh',
      howto: 'Hướng dẫn',
      localQuery: 'Truy vấn địa phương',
      news: 'Tin tức',
      question: 'Hỏi đáp',
    },
    coverage: {
      covered: 'Đã phủ',
      uncovered: 'Chưa phủ',
    },
    actions: {
      edit: 'Chỉnh sửa',
      generate: 'Tạo bài viết',
      confirmIntent: 'Xác nhận ý định',
      mergeTo: 'Gộp vào',
      archive: 'Lưu trữ',
      restore: 'Khôi phục',
      delete: 'Xóa',
      confirmDelete: 'Bạn có chắc muốn xóa từ khóa này?',
      confirmArchive: 'Bạn có chắc muốn lưu trữ từ khóa này?',
      confirmRestore: 'Bạn có chắc muốn khôi phục từ khóa này?',
        quickConfirm: '✓ Xác nhận',
},
    form: {
      keyword: 'Từ khóa',
      keywordPlaceholder: 'Tìm từ khóa...',
      language: 'Ngôn ngữ',
      languagePlaceholder: 'Chọn ngôn ngữ',
      intent: 'Ý định tìm kiếm',
      intentPlaceholder: 'Chọn ý định',
      intentDictHint: 'Tùy chọn — theo từ điển ý định 9 loại; có thể xác nhận sau',
      confirmStatusPlaceholder: 'Trạng thái xác nhận',
      priority: 'Ưu tiên',
      priorityPlaceholder: 'Chọn mức ưu tiên',
      coverageStatus: 'Độ phủ',
      coveragePlaceholder: 'Chọn trạng thái phủ',
      name: 'Từ khóa',
      nameRequired: 'Vui lòng nhập từ khóa',
      namePlaceholder: 'vd: casino trực tuyến Philippines',
      monthlyVolume: 'Lượng tìm kiếm hàng tháng',
      monthlyVolumePlaceholder: 'Ước tính lượng tìm kiếm hàng tháng',
      intentRequired: 'Vui lòng chọn ý định tìm kiếm',
      intentDesc: {
        info:  'Người dùng tìm kiếm thông tin, ví dụ "cách chọn casino trực tuyến"',
        nav:   'Người dùng tìm kiếm trang web cụ thể, ví dụ "đăng nhập [Your Brand]"',
        trans: 'Người dùng có ý định đăng ký hoặc nạp tiền, ví dụ "ưu đãi đăng ký casino"',
        comm:  'Người dùng so sánh sản phẩm, ví dụ "xếp hạng casino Philippines tốt nhất"',
      },
      remark: 'Ghi chú',
      remarkPlaceholder: 'Tùy chọn, thêm ngữ cảnh từ khóa',
        volumeSource: 'Nguồn lượng tìm kiếm',
    volumeSourcePlaceholder: 'Chọn nguồn lượng tìm kiếm',
},
    table: {
      keyword: 'Từ khóa',
      intent: 'Ý định',
      confirmStatus: 'Trạng thái xác nhận',
      priority: 'Ưu tiên',
      language: 'Ngôn ngữ',
      monthlyVolume: 'Lượng TK',
      coveredArticleCount: 'Bài đã tạo',
      coverageStatus: 'Độ phủ',
      relatedArticles: 'Bài viết',
      updateTime: 'Cập nhật',
      articles: 'bài viết',
      action: 'Thao tác',
        searchIntent: 'Ý định tìm kiếm',
},
    stats: {
      total: 'Tổng từ khóa',
      active: 'Đang hoạt động',
      weeklyNew: 'Mới tuần này',
      archived: 'Đã lưu trữ',
      covered: 'Bài viết đã phủ',
      highPriority: 'Ưu tiên cao',
      avgVolume: 'Lượng tìm kiếm trung bình',
      avgVolumeEmpty: 'Chưa có dữ liệu',
      avgVolumeBasis: 'Trung bình tính từ {n}/{m} từ khóa có dữ liệu lượng tìm kiếm',
      avgVolumeLowSample: 'quá ít từ khóa có dữ liệu — giá trị tham khảo thấp',
      thisWeek: 'tuần này',
      coverageRate: 'Tỷ lệ phủ',
      needCover: 'cần phủ gấp',
        pendingConfirm: 'Chờ xác nhận (ưu tiên cao)',
    generatable: 'Có thể tạo bài',
    coveredArticles: 'Bài đã tạo',
},
    exportCsv: 'Xuất CSV',
    importConfirm: 'Bắt đầu nhập',
    importUploadText: 'Nhấp hoặc kéo file CSV để tải lên',
    importUploadHint: 'Hỗ trợ file .csv hoặc .txt',
    selectedCount: 'Đã chọn {count}',
    statusActive: 'Hoạt động',
    statusArchived: 'Đã lưu trữ',
    pleaseSelectStatus: 'Chọn trạng thái',
    batchDeleteUnavailable: 'API xóa từ khóa hàng loạt chưa khả dụng, vui lòng liên hệ backend',
    batchImportFailed: 'Gọi API nhập từ khóa hàng loạt thất bại, vui lòng liên hệ backend',
    exportMaxLimitWarn: 'Dữ liệu vượt quá {max} hàng, chỉ xuất {max} hàng đầu',
    totalRows: 'Tổng {total}',
    keywordCol: 'Từ khóa',
    langDisplay: {
      'en-US': 'English',
      'zh-CN': '中文',
      'vi-VN': 'Tiếng Việt',
      'tl-PH': 'Filipino',
    },
    priorityFull: {
      high: 'Ưu tiên cao',
      medium: 'Ưu tiên trung bình',
      low: 'Ưu tiên thấp',
    },
    importPreview: 'Xem trước',
    importDone: 'Hoàn thành',
    importConfirmWithCount: 'Xác nhận ({count})',
    importParsing: 'Đang phân tích...',
    importParsedCount: 'Đã phân tích {count} dòng',
    importReupload: 'Tải lại',
    importStatusCol: 'Kết quả nhập',
    importSelectAll: 'Chọn tất cả',
    importDeselectAll: 'Bỏ chọn tất cả',
    importSuccessCount: '✅ Thành công {count}',
    importFailCount: '❌ Thất bại {count}',
    importExistSkipHint: 'Từ khóa đã tồn tại sẽ được bỏ qua tự động.',
    importStatusSuccess: '✅ Thành công',
    miningReason: {
      duplicate: 'Từ khóa trùng lặp',
      keywordExist: 'Từ khóa đã tồn tại',
      invalidKeyword: 'Từ khóa không hợp lệ',
      langNotSupported: 'Ngôn ngữ không được hỗ trợ',
      limitExceeded: 'Đã đạt giới hạn',
    },
    aiMining: {
      btn: 'AI khai thác',
      title: 'AI Khai thác từ khóa',
      description: 'AI sẽ tự động khai thác các từ khóa đuôi dài liên quan dựa trên từ khóa gốc và phân tích ý định tìm kiếm của từng từ.',
      form: {
        seed: {
          label: 'Từ khóa gốc',
          extra: 'Nhập một từ khóa cốt lõi, AI sẽ tạo ra các biến thể, từ khóa đuôi dài và từ khóa dạng câu hỏi xung quanh nó',
        },
        directions: {
          label: 'Hướng khai thác',
          longTail: 'Biến thể đuôi dài (vd: "best online casino PH 2025")',
          qa: 'Từ khóa hỏi (vd: "is online casino legal in Philippines")',
          compare: 'So sánh (vd: "[Your Brand] vs đối thủ")',
          geo: 'Địa phương (vd: "casino Manila", "casino Cebu")',
        },
        language: {
          label: 'Ngôn ngữ mục tiêu',
          mixed: 'Hỗn hợp (Đa ngôn ngữ)',
        },
        competition: {
          label: 'Mức độ cạnh tranh',
          extra: 'Website mới nên nhắm vào từ khóa cạnh tranh thấp để nhanh chóng có thứ hạng',
          all: 'Tất cả mức độ cạnh tranh',
          low: 'Cạnh tranh thấp (dễ xếp hạng, tốt cho web mới)',
          medium: 'Cạnh tranh trung bình',
          high: 'Cạnh tranh cao',
        },
        count: {
          label: 'Số lượng khai thác',
          fast: '10 từ khóa (Nhanh)',
          recommended: '20 từ khóa (Khuyến nghị)',
          deep: '30 từ khóa (Chuyên sâu)',
        },
      },
      action: {
        start: 'Bắt đầu khai thác AI',
        add: 'Thêm vào Trung tâm từ khóa',
        close: 'Đóng',
      },
      loading: 'AI đang phân tích ý định tìm kiếm và từ khóa đuôi dài...',
      result: {
        title: 'Kết quả khai thác',
        note: 'Các từ khóa trùng lặp với từ khóa hiện có đã được lọc tự động. Chọn các từ bạn muốn thêm, sau đó nhấp "Thêm vào Trung tâm từ khóa".',
      },
      intent: {
        informational: 'Thông tin', info: 'Thông tin',
        navigational: 'Điều hướng', nav: 'Điều hướng',
        transactional: 'Giao dịch', trans: 'Giao dịch',
        commercial: 'Thương mại', comm: 'Thương mại',
      },
      competition: {
        low: 'Cạnh tranh thấp (dễ xếp hạng, tốt cho web mới)',
        medium: 'Cạnh tranh trung bình',
        high: 'Cạnh tranh cao',
      },
      competitionCol: 'Cạnh tranh',
      relevance: 'Mức độ liên quan',
      selected: 'Đã chọn {count} từ khóa',
      countUnit: 'từ khóa',
      estimatedCost: 'Chi phí ước tính: ~',
      seedRequired: 'Vui lòng nhập từ khóa gốc',
      directionRequired: 'Vui lòng chọn ít nhất 1 hướng khai thác',
      addSuccess: 'Đã thêm thành công {count} từ khóa',
      selectAll: 'Chọn tất cả',
      modelLabel: 'Mô hình AI',
      modelRequired: 'Vui lòng chọn mô hình AI',
      modelPlaceholder: 'Chọn mô hình AI',
      addStatusCol: 'Trạng thái thêm',
      addStatusSuccess: 'Thành công',
      addStatusFail: 'Thất bại',
      addResultEmptyWarn: 'Kết quả trống, vui lòng làm mới danh sách để xác nhận',
    },
      selectedRows: 'Đã chọn {count}',
    batchConfirmUnavailable: 'API xác nhận hàng loạt chưa khả dụng',
    batchConfirmIntent: 'Xác nhận phân loại hàng loạt',
    batchConfirmTitle: 'Xác nhận ý định hàng loạt',
    batchConfirmNoPending: 'Không có từ khóa chờ xác nhận trong lựa chọn',
    batchConfirmNeedIntent: 'Vui lòng chọn ý định cho ít nhất một từ khóa',
    batchConfirmSuccess: 'Đã xác nhận ý định hàng loạt',
    batchMergeTypo: 'Gộp typo hàng loạt',
    batchMergeNoTypo: 'Không có từ khóa typo trong lựa chọn',
},

  score: {
      aiReworkBtn: "Viết lại bằng AI",
      submitOnlyDraft: "Chỉ bài viết nháp mới có thể gửi duyệt",
    title: 'Công cụ chấm điểm SEO/GEO',
    checkArticle: 'Chọn bài viết',
    checkArticlePlaceholder: 'Chọn bài viết để chấm điểm',
    startScore: 'Bắt đầu chấm điểm',
    checkUrl: 'Chấm điểm theo URL',
    checkUrlPlaceholder: 'Nhập URL bài viết',
    checkContent: 'Nhập nội dung thủ công',
    articleTitle: 'Tiêu đề bài viết',
    articleTitlePlaceholder: 'Nhập tiêu đề bài viết',
    articleTitleRequired: 'Vui lòng nhập tiêu đề bài viết',
    articleContent: 'Nội dung bài viết',
    articleContentPlaceholder: 'Dán HTML hoặc văn bản thuần',
    articleContentRequired: 'Vui lòng nhập nội dung bài viết',
    targetKeyword: 'Từ khóa mục tiêu',
    targetKeywordPlaceholder: 'Nhập từ khóa mục tiêu',
    seoDescription: 'Meta Description',
    seoDescriptionPlaceholder: 'Nhập Meta Description',
    startCheck: 'Bắt đầu chấm điểm',
    checking: 'Đang chấm điểm...',
    totalScore: 'Điểm tổng hợp',
    seoScore: 'Điểm SEO',
    geoScore: 'Điểm GEO',
    level: {
      excellent: 'Có thể xuất bản',
      good: 'Cần tối ưu',
      warning: 'Cần cải thiện',
      fail: 'Cần chỉnh sửa',
    },
    checkItem: {
      status: {
        pass: 'Đạt',
        warn: 'Cảnh báo',
        fail: 'Không đạt',
      },
    },
    seoGroup: 'Kiểm tra SEO',
    geoGroup: 'Kiểm tra GEO',
    suggestion: 'Gợi ý tối ưu',
    noResult: 'Vui lòng chọn bài viết để bắt đầu chấm điểm',
    tagSuggest: 'Gợi ý',
    tagTip: 'Mẹo',
    btnSubmit: 'Gửi duyệt',
    btnContinue: 'Tiếp tục tối ưu',
    btnEdit: 'Chỉnh sửa',
    btnAIRegenerate: 'Tạo lại bằng AI',
    btnRescore: 'Chấm điểm lại',
    btnBackToEditor: 'Quay lại chỉnh sửa',
    submitTooltipNoScore: 'Vui lòng chấm điểm trước',
    submitTooltipBelow80: 'Cần điểm ≥ 70 để gửi duyệt (hiện tại {{score}})',
    submitSuccess: 'Gửi duyệt thành công',
    submitFail: 'Gửi duyệt thất bại, vui lòng thử lại',
    submitFailTransition: 'Chuyển trạng thái thất bại — bài viết không thể gửi duyệt ở trạng thái hiện tại',
    scoreFail: 'Đánh giá thất bại, vui lòng thử lại',
    scoreError: 'Lỗi yêu cầu đánh giá, vui lòng thử lại',
    history: 'Lịch sử chấm điểm',
    historyEmpty: 'Chưa có lịch sử',
    pleaseSelectModel: 'Vui lòng chọn mô hình AI trước',
    pleaseSelectArticle: 'Vui lòng chọn bài viết trước',
    selectModelLabel: 'Chọn mô hình AI',
    selectModelPlaceholder: 'Chọn mô hình AI',
    articleSearchHint: 'Tìm kiếm theo tiêu đề',
    viewMore: 'Xem thêm',
    checks: {
      titleKeyword: 'Tiêu đề chứa từ khóa mục tiêu',
      metaDescLength: 'Độ dài Meta Description hợp lệ',
      headingStructure: 'Cấu trúc tiêu đề H2/H3 đầy đủ',
      keywordDensity: 'Mật độ từ khóa phù hợp',
      internalLinks: 'Chứa liên kết nội bộ',
      ogImage: 'Đã cấu hình OG image',
      canonicalUrl: 'Đã cấu hình Canonical URL',
      faqModule: 'Chứa mô-đun FAQ',
      blufFormat: 'Định dạng BLUF (câu trả lời trực tiếp đầu)',
      namedAuthor: 'Tác giả được đặt tên + Person Schema',
      neutralTone: 'Giọng điệu trung lập và có thẩm quyền',
      comparisonTable: 'Chứa bảng so sánh',
      authorityData: 'Chứa tuyên bố có thẩm quyền và dữ liệu cụ thể',
      freshness: 'Độ tươi mới của nội dung',
    },
      totalScoreFormula: 'Tổng hợp = (SEO + GEO) / (70 + 70)',
    checkGroupMaxScore: '{{itemCount}} mục · tối đa {{max}}',
    btnRegenWithIssues: 'Tạo lại với vấn đề',
    regenTooltipNoScore: 'Hãy chạy đánh giá trước khi tạo lại',
    regenTooltipPassed: 'Điểm đã đạt ngưỡng, có thể tạo lại nếu cần',
},
  aiGenerator: {
    reworkBanner: '🤖 Chế độ viết lại AI: đang viết lại "{title}" — nhấn Lưu nháp sẽ cập nhật bài viết gốc',
    title: 'Tạo nội dung AI',
    cardTitle: 'Thông số tạo',
    previewTitle: 'Xem trước nội dung',
    historyTitle: 'Lịch sử tạo',
    historyCount: '10 lần gần nhất',
    startBtn: 'Bắt đầu tạo AI',
    saveDraft: 'Lưu nháp',
    saveDraftDone: 'Đã lưu nháp',
    updateArticle: 'Cập nhật bài viết',
    goScoreBtn: 'Đi đến chấm điểm',
    goScore: '📊 Chấm điểm',
    submitReview: '📤 Gửi duyệt',
    submitReviewBtn: 'Gửi duyệt',
    emptyHint: 'Cấu hình thông số và nhấp “Tạo AI”',
    emptySubHint: 'AI sẽ tạo bài viết đầy đủ tối ưu SEO + GEO',
    generating: 'AI đang viết...',

    reuseParams: 'Tái sử dụng thông số',
    viewHistory: 'Xem',
    historyTip: '“Tái sử dụng thông số”: tạo lại với cùng từ khóa, độ dài, giọng. “Xem”: xem nội dung đã tạo trước, có thể lưu nháp.',
    form: {
      keyword: 'Từ khóa mục tiêu',
      keywordRequired: 'Vui lòng chọn từ khóa mục tiêu',
      keywordPlaceholder: 'Chọn từ trung tâm từ khóa...',
      customKeyword: 'Hoặc nhập từ khóa trực tiếp',
      customKeywordPlaceholder: 'Nhập từ khóa tùy chỉnh...',
      articleType: 'Loại bài viết',
      author: 'Tác giả',
      authorRequired: 'Vui lòng chọn tác giả',
      authorPlaceholder: 'Chọn tác giả...',
      coverImageSize: 'Kích thước ảnh bìa',
      coverImageSizeRecommended: '(Khuyến nghị, Chuẩn OG)',
      language: 'Ngôn ngữ',
      wordCount: 'Độ dài bài viết',
      extraReq: 'Yêu cầu bổ sung',
      extraReqPlaceholder: 'Ví dụ: nhấn mạnh uy tín giấy phép PAGCOR...',
      secondaryKeywords: 'Từ khóa phụ (3-5)',
      secondaryKeywordsPlaceholder: 'Chọn từ trung tâm từ khóa (nhiều)',
      longTailQuestions: 'Câu hỏi đuôi dài (3-5)',
      longTailQuestionsPlaceholder: 'Mỗi dòng một câu hỏi',
      aiSuggestLongTailBtn: 'Gợi ý AI',
      aiSuggestLongTailNoKeyword: 'Vui lòng chọn từ khóa mục tiêu trước',
      aiSuggestLongTailEmpty: 'AI chưa tạo được câu hỏi; vui lòng nhập thủ công',
      aiSuggestLongTailDisabledHint: 'API gợi ý AI chưa khả dụng; vui lòng nhập thủ công',
      mustInclude: 'Sự thật bắt buộc',
      mustIncludePlaceholder: 'Sự thật bài viết phải có',
      mustAvoid: 'Cần tránh',
      mustAvoidPlaceholder: 'Từ/tuyên bố bài viết phải tránh',
      targetWordCount: 'Số từ mục tiêu',
      wordsUnit: 'từ',
      wordCountWarning: 'Số từ nằm ngoài khoảng đề xuất cho loại nội dung này',
      presetApplied: 'Đã áp dụng mặc định theo loại nội dung',
      relatedEntities: 'Thực thể liên quan',
      relatedEntitiesPlaceholder: 'Chọn thực thể liên quan',
      entityTypeFilter: 'Loại thực thể',
      entityTypeFilterPlaceholder: 'Lọc theo loại',
      entityTypePerson: 'Người',
      entityTypeOrganization: 'Cơ quan quản lý',
      entityTypeProduct: 'Trò chơi',
      entityTypeConcept: 'Khái niệm',
      entityTypePlace: 'Địa điểm',
      entityTypeBrand: 'Thương hiệu',
      entityTypeEvent: 'Hoạt động',
      inlinkSuggest: 'Đề xuất liên kết nội bộ',
      inlinkSuggestBtn: 'Lấy đề xuất',
      inlinkSuggestEmpty: 'Không tìm thấy bài viết phù hợp',
      mustIncludeInlinks: 'Liên kết nội bộ bắt buộc',
      entityRelSaveError: 'Lưu quan hệ thực thể thất bại, vui lòng thử lại',
      keywordIntent: {
        informational: 'Thông tin',
        navigational: 'Điều hướng',
        transactional: 'Giao dịch',
      },
      keywordVolume: 'Lượt tìm/tháng',
      keywordCovered: 'Đã phủ',
      keywordUncovered: 'Chưa phủ',
      switchKeywordTitle: 'Chuyển từ khóa mục tiêu',
      switchKeywordContent: 'Đang tạo nội dung. Chuyển từ khóa sẽ ngắt quá trình. Xác nhận chuyển?',
      contentType: 'Loại nội dung',
      contentTypeRequired: 'Vui lòng chọn loại nội dung',
      contentTypePlaceholder: 'Chọn loại nội dung...',
      schemaType: 'Loại Schema',
      schemaTypePlaceholder: 'Chọn loại Schema...',
      schemaTypeHint: 'Tự gợi ý theo loại nội dung; có thể chỉnh',
      geoMode: 'Chế độ GEO',
      geoModePlaceholder: 'Chọn chế độ GEO...',
      modelCode: 'Mô hình tạo bài viết',
      modelCodePlaceholder: 'Chọn mô hình tạo bài viết',
      modelCodeRequired: 'Vui lòng chọn mô hình tạo bài viết',
      imageModelCode: 'Mô hình tạo ảnh bìa',
      imageModelCodePlaceholder: 'Chọn mô hình tạo ảnh bìa (tùy chọn)',
      imageModelCodeRequired: 'Vui lòng chọn mô hình tạo ảnh bìa',
      imageModelCodeTip: 'Không chọn sẽ không tạo ảnh bìa, tốc độ tạo nhanh hơn',
      langSimplifiedChinese: 'Tiếng Trung giản thể',
      category: 'Danh mục bài viết',
      categoryPlaceholder: 'Chọn danh mục (tùy chọn)',
      includeCitations: 'Bao gồm trích dẫn & liên kết ngoài',
      includeCitationsExtra: 'Bao gồm thẻ cite hoặc liên kết ngoài, tăng điểm GEO',
      includeFaq: 'Bao gồm đoạn hỏi đáp FAQ',
      includeFaqExtra: 'Chứa H2 dạng hỏi đáp, cải thiện điểm trích xuất câu trả lời GEO',
      contentLength: 'Độ dài bài viết',
      contentLengthShort: 'Ngắn (500-800 từ)',
      contentLengthStandard: 'Tiêu chuẩn (1000-2000 từ)',
      contentLengthLong: 'Dài (2500-4000 từ)',
    },
    preview: {
      articleTitle: 'Tiêu đề bài viết',
      articleTitleRequired: 'Vui lòng nhập tiêu đề bài viết',
      articleTitlePlaceholder: 'Nhập tiêu đề bài viết...',
      slug: 'URL Slug',
      slugRequired: 'Vui lòng nhập URL slug',
      slugPlaceholder: 'Tự động tạo, có thể sửa',
      scoreDisabledTip: 'Vui lòng lưu nháp trước',
      submitDisabledNoScore: 'Vui lòng hoàn thành chấm điểm trước',
      submitDisabledLowScore: 'Điểm chưa đạt yêu cầu (cần ≥60)',
      summary: 'Tóm tắt bài viết',
      summaryPlaceholder: 'Tóm tắt 2-3 câu về bài viết...',
      ogTitle: 'OG Title',
      ogTitlePlaceholder: 'Mặc định: giống SEO Title',
      ogDescription: 'OG Description',
      ogDescriptionPlaceholder: 'Mặc định: giống Meta Description',
      coverImage: 'Ảnh bìa',
      coverImageHint: 'Khuyến nghị: 1200×630px, JPG/PNG/WEBP, tối đa 2MB. Cũng được dùng làm OG Image.',
      aiGeneratedImage: 'Ảnh bìa do AI tạo',
      generateCoverImage: 'Tạo ảnh',
      regenerateCoverImage: 'Tạo lại ảnh',
      generatingImage: 'Đang tạo ảnh bìa...',
      imageGenOk: 'Tạo ảnh bìa thành công',
      imageGenEmpty: 'Tạo ảnh thất bại, vui lòng thử lại',
      regenerateImage: 'Tạo lại ảnh',
      regenerateImageSuccess: 'Tạo lại ảnh thành công',
      regenerateImageFailed: 'Tạo ảnh thất bại, vui lòng thử lại',
      coverImageUploadFail: 'Tải lên ảnh bìa thất bại, vui lòng thử lại',
      noTaskForImage: 'Chế độ viết lại không hỗ trợ tạo ảnh AI, vui lòng tải lên thủ công',
      selectImageModelFirst: 'Vui lòng chọn mô hình ảnh trước',
        metaDescWarnHint: 'Gần đến giới hạn, nên rút ngắn',
    metaDescOverHint: 'Vượt quá giới hạn 200 ký tự',
},
    articleType: {
      guide: '📖 Hướng dẫn chuyên sâu',
      review: '⭐ Đánh giá & So sánh',
      news: '📰 Tin tức',
      faq: '❓ FAQ',
    },
    wordCount: {
      standard: 'Tiêu chuẩn (1500-2000 từ)',
      short: 'Ngắn (800-1200 từ)',
      long: 'Dài (2500-3500 từ)',
    },
    historyStatus: {
      draft: 'Nháp',
      published: 'Đã xuất bản',
      discarded: 'Đã hủy',
      pending_review: 'Chờ duyệt',
    },
    historyCol: {
      time: 'Thời gian',
      keyword: 'Từ khóa',
      articleTitle: 'Tiêu đề bài viết',
      model: 'Mô hình',
      score: 'Điểm',
      status: 'Trạng thái',
      action: 'Thao tác',
        articleType: 'Loại nội dung',
},
    steps: {
      config: 'Cấu hình',
      generate: 'Tạo AI',
      preview: 'Xem trước',
      score: 'Kiểm tra điểm',
      submit: 'Gửi duyệt',
    },
    genStep: {
      intent: 'Phân tích từ khóa và ý định tìm kiếm',
      structure: 'Xây dựng cấu trúc bài viết và tiêu đề',
      content: 'Viết nội dung chính và phần FAQ',
      meta: 'Tạo SEO meta và trường OG',
      image: 'Tạo ảnh bìa',
    },
    generatingSteps: {
      intent: 'Phân tích ý định tìm kiếm',
      research: 'Nghiên cứu cấu trúc nội dung cạnh tranh',
      content: 'Tạo nội dung tối ưu SEO',
      faq: 'Tạo các cặp FAQ',
      meta: 'Tạo thẻ Meta',
      links: 'Đề xuất liên kết nội bộ',
    },
    geoSectionTitle: '🧠 Tùy chọn tối ưu GEO',
    generateError: 'Tạo thất bại',
    generateErrorFallback: 'Tạo nội dung AI thất bại. Vui lòng thử lại.',
    retryBtn: 'Thử lại',
    articleTypeOpt: {
      deepGuide: '📖 Hướng dẫn chuyên sâu',
      review:    '⭐ Đánh giá & So sánh',
      news:      '📰 Tin tức',
      faq:       '❓ FAQ',
      tutorialGuide: '🎓 Hướng dẫn',
      howto: '🎯 Hướng dẫn chơi',
      comparison: '⭐ Đánh giá & So sánh',
      listicle: '📋 Danh sách tổng hợp',
      landingPage: '🛬 Trang đích',
      brand:     'Thương hiệu',
      brandTypo: 'Lỗi chính tả thương hiệu',
      nav:       'Điều hướng',
      trust:     '🛡️ Độ tin cậy / Hợp pháp',
      tutorial:  'Hướng dẫn',
      local:     '📍 Trang đích địa phương',
      product:   '🎰 Trang sản phẩm/game',
      event:     '🎁 Khuyến mãi',
      info:      'Thông tin',
    },
    geoModeOpt: {
      normal:           'Thông thường',
      normalDesc:       'Cấu trúc bài viết tiêu chuẩn, phù hợp với hầu hết nội dung',
      bluf:             'Định dạng BLUF (Khuyến nghị)',
      blufDesc:         'Đưa kết luận lên đầu, AI dễ trích xuất tóm tắt hơn',
      compareTable:     'Bảng so sánh',
      compareTableDesc: 'Trình bày so sánh dạng bảng, phù hợp đánh giá sản phẩm',
      qaCluster:        'Cụm hỏi đáp',
      qaClusterDesc:    'Tổ chức nội dung thành cụm câu hỏi - trả lời',
      stepByStep:       'Từng bước',
      stepByStepDesc:   'Hướng dẫn từng bước có đánh số, phù hợp tutorial/how-to',
      notReady: 'Backend chưa hỗ trợ chế độ này; sắp mở',
    },
    stepName: {
      configParams: 'Phân tích tham số',
      aiGenerate:   'AI Tạo nội dung',
    },
    unknownStatus: 'Trạng thái không xác định {code}, vui lòng liên hệ quản trị viên',
    pollingTimeout: 'Tạo nội dung quá thời gian. Đã dừng polling. Vui lòng làm mới trang và thử lại.',
    cancelTaskBtn: 'Hủy tác vụ',
    deleteTaskBtn: 'Xóa',
    runScoreCheckBtn: 'Chạy chấm điểm',
    finalizeBtn: 'Hoàn thành',
    taskHistoryTab: 'Tác vụ AI',
    publishedArticlesTab: 'Bài đã xuất bản',
    taskStatus: {
      created: 'Đã tạo',
      generating: 'Đang tạo',
      editing: 'Đang chỉnh sửa',
      reviewing: 'Đang duyệt',
      failed: 'Thất bại',
      cancelled: 'Đã hủy',
      finalized: 'Hoàn thành',
      unknown: 'Không xác định',
    },
    phase: {
      created: 'Chờ tạo',
      generating: 'Đang tạo',
      editing: 'Đã tạo',
      reviewing: 'Đang xét duyệt',
      finalized: 'Đã hoàn thiện',
      failed: 'Thất bại',
      cancelled: 'Đã hủy',
      unknown: 'Không xác định',
    },
    msg: {
      saveDraftOk: 'Đã lưu nháp. Tìm thấy trong Quản lý bài viết.',
      saveDraftFirst: 'Vui lòng lưu nháp trước khi gửi duyệt.',
      submitReviewConfirmTitle: 'Gửi duyệt',
      submitReviewConfirmContent: 'Gửi bài viết này để duyệt?',
      submitReviewDisabledHint: 'Đạt điểm yêu cầu trước khi gửi duyệt',
      scoreFirst: 'Vui lòng hoàn thành chấm điểm SEO/GEO (≥80) trước khi gửi duyệt.',
      submitReviewOk: 'Đã gửi duyệt thành công.',
      viewPending: 'Xem nội dung đã tạo trước (đang chờ API)',
      reuseOk: 'Đã tái sử dụng thông số. Vui lòng cấu hình lại và tạo.',
      submitReviewFieldsMissing: 'Gửi duyệt thất bại: thiếu trường bắt buộc. Vui lòng kiểm tra tiêu đề và nội dung.',
      pkCodeLookupFailed: 'Tạo task thành công nhưng không thể xác định ID task. Vui lòng làm mới trang và thử lại.',
      articleIdMissing: 'Đã lưu bài viết, nhưng không lấy được ID bài viết. Vui lòng làm mới và tiếp tục chỉnh sửa.',
      cancelOk: 'Đã hủy tác vụ.',
      deleteOk: 'Đã xóa tác vụ.',
      finalizeOk: 'Hoàn thành. Tìm bài viết trong Quản lý bài viết.',
      cancelConfirmTitle: 'Hủy tác vụ tạo nội dung này?',
      deleteConfirmTitle: 'Xóa tác vụ tạo nội dung này? Hành động này không thể hoàn tác.',
      scoreCheckStarted: 'Đã bắt đầu chấm điểm.',
      contentSyncFailed: 'Đồng bộ nội dung thất bại. Vui lòng lưu thủ công.',
      statusTransitionIllegal: 'Hành động này không được hỗ trợ ở trạng thái hiện tại.',
      noTaskForSubmit: 'Không tìm thấy tác vụ liên quan. Vui lòng tạo bài viết qua AI trước.',
    },
  },
  siteLink: {
    title: 'Liên kết nội bộ',
    addBtn: 'Thêm quy tắc',
    cardTitle: 'Quy tắc liên kết nội bộ',
    tip: 'Liên kết được tự động chèn khi render SSR. Liên kết thủ công có sẵn không bị trùng lặp. Quy tắc tự tạm dừng khi URL mục tiêu ngoại tuyến.',
    deleteOk: 'Đã xóa quy tắc',
    offlineTip: 'Mục tiêu ngoại tuyến',
    hitCountLabel: 'Khớp {n} bài',
    stat: {
      total: 'Tổng quy tắc',
      enabledRules: 'Đang bật',
      hitArticles: 'Bài viết được khớp',
      totalHits: 'Tổng lượt khớp',
    },
    col: {
      ruleName: 'Tên quy tắc',
      keyword: 'Từ khóa',
      targetUrl: 'URL mục tiêu',
      lang: 'Ngôn ngữ',
      hitArticles: 'Số bài khớp',
      lastHit: 'Khớp gần nhất',
      status: 'Trạng thái',
      action: 'Thao tác',
    },
    drawer: {
      title: 'Chi tiết khớp',
      articleId: 'ID bài viết',
      hitCount: 'Số lần khớp',
      lastHit: 'Khớp gần nhất',
      action: 'Thao tác',
      viewArticle: 'Xem bài viết',
      empty: 'Quy tắc này chưa khớp bài viết nào',
    },
    statusLabel: { enabled: 'Kích hoạt', disabled: 'Tạm dừng' },
    edit: {
      createTitle: 'Thêm quy tắc liên kết nội bộ',
      editTitle: 'Chỉnh sửa quy tắc liên kết nội bộ',
      ruleName: 'Tên quy tắc',
      ruleNameRequired: 'Vui lòng nhập tên quy tắc',
      ruleNamePlaceholder: 'Ví dụ: PAGCOR license hướng dẫn',
      lang: 'Ngôn ngữ',
      langRequired: 'Vui lòng chọn ngôn ngữ',
      langPlaceholder: 'Chọn ngôn ngữ',
      sourcePattern: 'Từ khóa kích hoạt / Pattern',
      sourcePatternRequired: 'Vui lòng nhập từ khóa hoặc pattern',
      sourcePatternPlaceholder: 'Ví dụ: PAGCOR license',
      keywordExtra: 'Khi từ khóa này xuất hiện trong bài viết, nó sẽ tự động trở thành liên kết.',
      targetUrl: 'URL mục tiêu',
      targetUrlRequired: 'Vui lòng nhập URL',
      targetUrlPlaceholder: 'Ví dụ: /article/pagcor-casino-guide',
      targetUrlExtra: 'Phải là URL nội bộ, bắt đầu bằng /',
      anchorText: 'Văn bản neo',
      anchorTextPlaceholder: 'Mặc định: dùng từ khóa',
      matchType: 'Kiểu khớp',
      matchTypeExtra: 'Chính xác: chỉ khớp từ giống hệt. Chứa: kể cả xuất hiện một phần. Regex: dùng biểu thức chính quy.',
      exactMatch: 'Khớp chính xác (khuyến nghị)',
      containsMatch: 'Khớp chứa — văn bản có chứa từ khóa',
      regexMatch: 'Khớp Regex — dùng biểu thức chính quy',
      maxPerPage: 'Số lần thay thế tối đa mỗi trang',
      maxLinksExtra: 'Thường đặt 1 là đủ.',
      priority: 'Độ ưu tiên',
      priorityTooltip: 'Độ ưu tiên càng cao (số càng lớn), quy tắc càng được khớp trước. Khi nhiều quy tắc có từ khóa trùng nhau, quy tắc có độ ưu tiên cao hơn sẽ có hiệu lực trước. Nên đặt độ ưu tiên cao hơn cho từ dài/từ chính xác.',
      status: 'Trạng thái',
      statusEnabled: 'Kích hoạt',
      statusDisabled: 'Tạm dừng',
      saveOk: 'Đã cập nhật quy tắc',
      createOk: 'Đã tạo quy tắc',
      regexConfirmTitle: 'Dùng regex?',
      regexConfirmContent: 'Regex sai có thể làm hỏng việc render trang. Vui lòng đảm bảo bạn hiểu cú pháp regex.',
      lockedTooltip: 'Để đổi ngôn ngữ hoặc kiểu khớp, hãy xóa quy tắc và tạo mới',
      applyScopeWarning: 'Quy tắc này áp dụng cho tất cả bài đã xuất bản của ngôn ngữ đã chọn. Hiện không hỗ trợ giới hạn theo phân loại hay loại trừ bài viết.',
      advancedSettings: 'Cài đặt nâng cao',
      priorityHigh: 'Cao (ưu tiên khớp)',
      priorityMedium: 'Trung bình (mặc định)',
      priorityLow: 'Thấp',
      articlePickerLabel: 'Chọn từ bài đã xuất bản (tùy chọn)',
      articlePickerPlaceholder: 'Tìm tiêu đề bài viết',
      articlePickerNeedLang: 'Vui lòng chọn ngôn ngữ trước',
      articlePickerExtra: 'Chọn bài viết sẽ tự điền URL ở trên',
      conflictTitle: 'Phát hiện trùng từ khóa',
      conflictDesc: 'Quy tắc mới chứa hoặc bị chứa trong các quy tắc dưới đây. Khi khớp, quy tắc có độ ưu tiên cao hơn thắng. Tiếp tục?',
    },
    frm: {
      keyword: 'Từ khóa',
      keywordPlaceholder: 'Tìm kiếm từ khóa hoặc URL...',
      ruleName: 'Tên quy tắc',
      ruleNamePlaceholder: 'Tìm theo tên quy tắc...',
      status: 'Trạng thái',
      statusAll: 'Tất cả trạng thái',
      lang: 'Ngôn ngữ',
      langPlaceholder: 'Tất cả ngôn ngữ',
    },
      deleteConfirmTitle: 'Xác nhận xóa?',
    deleteConfirmContent: 'Hành động này không thể hoàn tác. Quy tắc và dữ liệu liên quan sẽ bị xóa vĩnh viễn.',
    deleteConfirmOk: 'Xóa',
},
  siteMap: {
    status: {
      included: 'Đã lập chỉ mục',
      waiting: 'Đang chờ',
      excluded: 'Đã loại trừ',
    },
    title: 'Quản lý Sitemap',
    regenBtn: 'Tái tạo',
    viewXmlBtn: 'Xem XML',
    viewAuthorsXmlBtn: 'XML Tác giả',
    authorsXmlPending: 'API chưa sẵn sàng',
    syncAuthorTip: 'Đồng bộ trang tác giả vào sitemap rồi xem trước XML',
    syncAuthorOk: 'Đã đồng bộ trang tác giả',
    regenOk: 'Đã tái tạo Sitemap',
    cardTitle: 'Cấu hình đường dẫn',
    xmlModalTitle: 'Xem trước sitemap.xml',
    toggleFail: 'Thao tác thất bại, đã hoàn tác',
    addBtn: 'Thêm URL',
    xmlEmpty: 'Nhấn \'Xem XML\' để tạo',
    xmlLoading: 'Đang tạo…',
    frm: { pageType: 'Loại trang', lang: 'Ngôn ngữ', localIndexStatus: 'Trạng thái' },
    col: { path: 'Mẫu đường dẫn', pageUrl: 'URL trang', type: 'Loại', pageType: 'Loại trang', lang: 'Ngôn ngữ', include: 'Thu thập', localIndexStatus: 'Trạng thái thu thập', changefreq: 'Tần suất cập nhật', priority: 'Độ ưu tiên', action: 'Thao tác' },
    edit: { titleNew: 'Thêm URL Sitemap', titleEdit: 'Sửa URL Sitemap', pageTypeRequired: 'Vui lòng chọn loại trang', pageTypePlaceholder: 'Chọn loại trang', pageUrlRequired: 'Vui lòng nhập URL', pageUrlInvalid: 'URL không hợp lệ (đường dẫn tương đối như /article/slug hoặc URL đầy đủ)', pageUrlPlaceholder: '/article/my-slug hoặc https://example.com/page', langRequired: 'Vui lòng chọn ngôn ngữ', langPlaceholder: 'Chọn ngôn ngữ', includeInSitemap: 'Đưa vào sitemap.xml', includeInSitemapHint: 'Chỉ trang có trạng thái Đã lập chỉ mục mới xuất ra sitemap.xml' },
    stat: { total: 'Số trang', indexed: 'Đã index', pending: 'Chờ index', excluded: 'Bị loại trừ' },
    pageType: { home: 'Trang chủ', article: 'Bài viết', category: 'Danh mục', login: 'Đăng nhập', author: 'Tác giả', template: 'Trang mẫu' },
    freq: {
      always: 'Luôn luôn',
      hourly: 'Mỗi giờ',
      daily: 'Hàng ngày',
      weekly: 'Hàng tuần',
      monthly: 'Hàng tháng',
      yearly: 'Hàng năm',
      never: 'Không bao giờ',
    },
    xmlModal: {
      urlLabel: 'URL: ',
      copyBtn: 'Sao chép',
      copyOk: 'Đã sao chép vào clipboard',
      indexFileLabel: '{file} (sitemap index · tổng hợp sitemap từng ngôn ngữ)',
      langFileLabel: '{file} (sitemap con {lang})',
      copyFail: 'Sao chép thất bại',
      lastGenLabel: 'Tạo lần cuối: ',
      openNewTab: 'Mở /sitemap.xml trong tab mới',
      closeBtn: 'Đóng',
    },
    statDesc: {
      title: 'Giải thích chỉ số',
      total: 'Tổng số URL sitemap thực tế được tạo bởi máy chủ SSR, bao gồm tất cả các mẫu đường dẫn đã bật.',
      indexed: 'Từ Google Search Console API, đồng bộ hàng ngày — số trang đã được Google lập chỉ mục.',
      pending: 'Tổng trang trừ đã lập chỉ mục — đã gửi nhưng Google chưa xử lý.',
      excluded: 'Từ Google Search Console — bị loại trừ bởi thẻ noindex hoặc quy tắc robots.',
      gscTip: 'Dữ liệu Đã index và Bị loại trừ yêu cầu kết nối Google Search Console API. Hiển thị — khi chưa kết nối.',
    },
  },
  declDoc: {
    title: 'Tệp khai báo',
    robotsTab: 'robots.txt',
    llmsTab: 'llms.txt',
    save: 'Lưu',
    saveOk: 'Đã lưu',
    saveFailed: 'Lưu thất bại',
    publish: 'Xuất bản',
    publishOk: 'Xuất bản thành công',
    publishFailed: 'Xuất bản thất bại',
    robotsDesc: 'Kiểm soát quyền truy cập của công cụ tìm kiếm và bot AI.',
    advancedWarn: '⚠️ Chế độ nâng cao: quy tắc robots sai có thể chặn toàn bộ trang web.',
    llmsDesc: 'Tệp mô tả trang web cho AI. Cho AI biết bạn là ai.',
    botSwitchTitle: 'Bật/tắt nhanh bot AI',
    botTip: '💡 GEO cần cho phép bot AI truy cập.',
    siteUrlInvalid: 'Vui lòng nhập tên miền hợp lệ (vd: https://example.com)',
    siteUrlLabel: 'Tên miền',
    siteUrlHint: 'Dùng cho cả Sitemap trong robots.txt và URL bài viết trong llms.txt (chia sẻ giữa các tab)',
    brandNameLabel: 'Tên thương hiệu',
    brandNamePlaceholder: 'vd: [Your Brand]',
    taglineLabel: 'Khẩu hiệu',
    taglinePlaceholder: 'vd: PAGCOR licensed online casino',
    statusPublished: 'Đã xuất bản',
    statusDraft: 'Bản nháp',
    saveAndPublish: 'Lưu & xuất bản',
    robotsInfoBanner: 'Bật/tắt quyền thu thập của bot AI; có hiệu lực trong robots.txt sau khi lưu & xuất bản',
    brandIntroLabel: 'Giới thiệu thương hiệu',
    brandIntroPlaceholder: '2-3 câu giới thiệu thương hiệu, giấy phép, dịch vụ chính',
    guidesAutoTitle: 'Guides (tự động tạo từ bài viết đã xuất bản của ngôn ngữ này)',
    guidesEmpty: 'Chưa có bài viết {lang} đã xuất bản',
    guidesLangName: { 'en-US': 'tiếng Anh', 'zh-CN': 'tiếng Trung', 'vi-VN': 'tiếng Việt', 'tl-PH': 'tiếng Philippines' },
    guidesError: 'Không tải được danh sách bài viết',
    previewTitle: 'Xem trước trực tiếp',
    langLoadFail: 'Tải danh sách ngôn ngữ thất bại (có thể do quyền gọi chéo module); đã lùi về ngôn ngữ mặc định. Vui lòng nhờ backend kiểm tra quyền API quản lý đa ngôn ngữ.',
      historyBtn: 'Lịch sử',
    historyDrawerTitle: 'Lịch sử phiên bản',
    historyColVersion: 'Phiên bản',
    historyColStatus: 'Trạng thái',
    historyColTime: 'Thời gian',
    historyColAction: 'Thao tác',
    historyEmpty: 'Chưa có lịch sử phiên bản',
    historyLoadFailed: 'Tải lịch sử thất bại',
    historyNoContent: '(không có nội dung)',
    rollbackBtn: 'Hoàn tác',
    rollbackConfirmTitle: 'Xác nhận hoàn tác',
    rollbackConfirmContent: 'Thao tác này sẽ khôi phục phiên bản đã chọn làm bản nháp mới. Tiếp tục?',
    rollbackConfirmOk: 'Xác nhận',
    rollbackConfirmCancel: 'Hủy',
    rollbackOk: 'Hoàn tác thành công',
    rollbackFailed: 'Hoàn tác thất bại',
    llmsInfoBanner: 'llms.txt giúp các trình thu thập AI hiểu thương hiệu của bạn và trích dẫn nội dung chính xác.',
},
  health: {
    title: 'Kiểm tra sức khỏe SEO',
    rescanBtn: '🔄 Quét lại',
    scanNowBtn: 'Quét ngay',
    emptyHint: 'Chưa có snapshot. Hãy chạy lần quét đầu tiên.',
    scanOk: 'Quét xong. Điểm: ',
    scanFailed: 'Quét thất bại',
    scanResultEmpty: 'Kết quả quét không có dữ liệu, vui lòng thử lại sau',
    loadFailed: 'Tải thất bại',
    resolveOk: 'Đã đánh dấu đã xử lý',
    resolveFailed: 'Thao tác thất bại',
    scanTimeLabel: 'Lần quét gần nhất',
    contentFreshnessLabel: 'Độ tươi',
    authorCoverageLabel: 'Tác giả',
    schemaLabel: 'Schema',
    crawlerAccessLabel: 'Bot AI',
    severityHigh: 'cao',
    severityMedium: 'trung bình',
    severityLow: 'thấp',
    resolvedTag: 'đã xử lý',
    allHealthy: 'Tất cả đều OK 🎉',
    noIssues: 'Không có vấn đề',
    staleCard: 'Độ tươi của nội dung',
    staleCount: 'hết hạn',
    staleDesc: 'AI ưu tiên nội dung < 13 tuần. Bài viết chưa cập nhật 90+ ngày cần làm mới.',
    staleModalTitle: 'Bài viết cũ',
    staleModalClose: 'Đóng',
    authorCard: 'Độ phủ tác giả',
    authorDesc: 'E-E-A-T yêu cầu mỗi bài viết có tác giả + Person Schema.',
    authorManageBtn: 'Quản lý tác giả >',
    unsignedViewBtn: 'Xem bài chưa có tác giả >',
    unsignedModalTitle: 'Bài viết đã đăng chưa có tác giả',
    unsignedAssignBtn: 'Gán tác giả',
    unsignedEmpty: 'Tất cả bài đã đăng đều có tác giả',
    schemaCard: 'Độ phủ Schema',
    schemaDesc: 'SSR tự động chèn dữ liệu cấu trúc.',
    cwvCard: 'Core Web Vitals',
    cwvDesc: 'Nguồn: Google PageSpeed Insights (PSI), dữ liệu thật 28 ngày qua.',
    cwvWaitingPsi: 'Chờ kết nối PSI',
    col: {
      target: 'Đối tượng',
      severity: 'Mức độ',
      action: 'Thao tác',
      articleTitle: 'Tiêu đề',
      publishTime: 'Đã đăng',
    },
    actionEdit: 'Sửa',
    actionAiRefresh: 'Làm mới AI',
    actionMarkResolved: 'Đánh dấu đã xử lý',
    cwv: {
      lcp: 'LCP (Vẽ lại nội dung lớn nhất)',
      inp: 'INP (Tương tác đến khung tiếp theo)',
      cls: 'CLS (Dịch chuyển bố cục tích lũy)',
      lcpHint: 'Tốt < 2.5s',
      inpHint: 'Tốt < 200ms',
      clsHint: 'Tốt < 0.1',
      ratingGood: 'Tốt',
      ratingNeedsImprovement: 'Cần cải thiện',
      ratingPoor: 'Kém',
      ratingUnknown: '—',
    },
      actionReopen: 'Mở lại',
    reopenOk: 'Đã mở lại',
    reopenFailed: 'Thao tác thất bại',
    schemaModalTitle: 'Vấn đề Schema',
    showResolved: 'Hiển thị đã giải quyết',
},
  pageModel: {
    pageType: {
      home: 'Trang chủ',
      login: 'Trang đăng nhập',
      news: 'Danh sách bài viết',
      'news-category': 'Danh mục bài viết',
      loading: 'Trang đích',
      'authors-list': 'Danh sách tác giả',
    },
    title: 'Mẫu SEO trang',
    addBtn: '+ Tạo mẫu SEO trang',
    cardTitle: 'Mẫu SEO trang',
    alertTip: 'Quản lý Meta SEO cho các trang cố định (Trang chủ, VIP, Khuyến mãi...). Mỗi trang cấu hình độc lập theo ngôn ngữ.',
    allConfiguredTip: 'Tất cả trang cố định đã được cấu hình',
    notSet: 'Chưa thiết lập',
    ogMissing: 'Thiếu OG',
    missingDesc: 'Thiếu Description',
    editBtn: 'Sửa',
    deleteBtn: 'Xóa',
    deleteConfirm: 'Bạn có chắc muốn xóa mẫu này không?',
    deleteOk: 'Xóa thành công.',
    deleteError: 'Xóa thất bại. Vui lòng thử lại.',
    loadError: 'Tải dữ liệu thất bại. Vui lòng thử lại.',
    emptyText: 'Chưa có cấu hình SEO trang nào',
    toggleError: 'Cập nhật trạng thái thất bại. Đã hoàn tác.',
    frm: {
      keyword: 'Tìm kiếm',
      keywordPlaceholder: 'Tìm tên trang',
      pageKey: 'Page Key',
      pageKeyPlaceholder: 'Tìm theo page key (slug)',
      language: 'Ngôn ngữ',
      languagePlaceholder: 'Chọn ngôn ngữ',
      pageType: 'Loại trang',
      pageTypePlaceholder: 'Chọn loại trang',
      status: 'Trạng thái',
      statusPlaceholder: 'Chọn trạng thái',
      statusEnabled: 'Đang bật',
      statusDisabled: 'Đã tắt',
    },
    col: {
      pageName: 'Tên trang',
      pageKey: 'Page Key',
      language: 'Ngôn ngữ',
      titleDesc: 'SEO Title / Description',
      og: 'OG',
      robots: 'Robots',
      enabled: 'Bật/Tắt',
      action: 'Thao tác',
    },
    edit: {
      createTitle: 'Tạo mẫu SEO trang mới',
      editTitlePrefix: 'Chỉnh sửa SEO trang — ',
      pageType: 'Loại trang',
      pageTypeRequired: 'Vui lòng chọn loại trang',
      pageTypePlaceholder: 'Chọn loại trang',
      pageTypeExtra: 'Không thể thay đổi sau khi tạo',
      language: 'Ngôn ngữ',
      languageExtra: 'Không thể thay đổi sau khi tạo',
      seoTitle: 'SEO Title',
      seoTitleExtra: 'Khuyến nghị 50-60 ký tự',
      seoTitlePlaceholder: 'Nhập tiêu đề SEO hiển thị trên kết quả tìm kiếm',
      seoTitleRequired: 'Vui lòng nhập SEO Title',
      metaDesc: 'Meta Description',
      metaDescExtra: 'Khuyến nghị 100-160 ký tự',
      metaDescPlaceholder: 'Nhập mô tả meta hiển thị trên kết quả tìm kiếm',
      metaDescRequired: 'Vui lòng nhập Meta Description',
      canonical: 'Canonical URL',
      canonicalPlaceholder: 'https://example.com',
      canonicalExtra: "URL chính tắc. SSR tự động chèn <link rel='canonical'>",
      canonicalInvalid: 'Vui lòng nhập URL hợp lệ (ví dụ https://example.com)',
      pageName: 'Tên hiển thị trang',
      pageNameRequired: 'Vui lòng nhập tên hiển thị trang',
      pageNamePlaceholder: 'VD: Trang chủ, VIP, Khuyến mãi',
      langRequired: 'Vui lòng chọn ngôn ngữ',
      metaKeywords: 'Meta Keywords',
      metaKeywordsPlaceholder: 'Các từ khóa cách nhau bằng dấu phẩy',
      loadError: 'Tải dữ liệu mẫu thất bại.',
      ogSync: 'Đồng bộ SEO Title / Description',
      ogTitle: 'OG Title',
      ogTitlePlaceholder: 'Để trống để dùng SEO Title',
      ogDesc: 'OG Description',
      ogDescPlaceholder: 'Để trống để dùng Meta Description',
      ogSection: 'Chia sẻ mạng xã hội (Open Graph)',
      ogImage: 'Ảnh OG',
      ogImagePlaceholder: 'https://yoursite.com/og-image.jpg',
      ogImageExtra: 'Khuyến nghị 1200×630 — hiển thị trên thẻ chia sẻ Facebook / Twitter / LinkedIn',
      ogUploadText: 'Tải ảnh OG',
      serpPreviewTitle: 'Xem trước SERP Google',
      serpPreviewHint: 'Cập nhật theo thời gian thực. Google có thể hiển thị khác.',
      cancel: 'Hủy',
      save: 'Lưu',
      saveOk: 'Đã cập nhật mẫu SEO',
      createOk: 'Đã tạo mẫu SEO',
      saveError: 'Lưu thất bại. Vui lòng thử lại.',
      enabled: 'Trạng thái',
      enabledOn: 'Bật',
      enabledOff: 'Tắt',
    },
      ogComplete: 'Đầy đủ',
},
  author: {
    titleAdd: 'Thêm tác giả',
    titleEdit: 'Sửa tác giả',
    addBtn: 'Thêm tác giả',
    viewAuthorPage: 'Xem trang tác giả',
    viewAuthorPageUnavailable: 'Chưa cấu hình tên miền (h5BaseUrl); không thể mở trang tác giả',
    col: {
      avatar: 'Ảnh đại diện',
      displayName: 'Tên hiển thị',
      slug: 'Slug',
      jobTitle: 'Chức danh',
      socials: 'Mạng xã hội',
      articleCount: 'Bài viết',
      status: 'Trạng thái',
      createTime: 'Ngày tạo',
      authorPage: 'Trang tác giả',
      action: 'Thao tác',
        expertiseTags: 'Chuyên môn',
    redditNoSameAs: 'Reddit — không đưa vào sameAs (theo SOP)',
},
    form: {
      displayName: 'Tên hiển thị',
      displayNameRequired: 'Vui lòng nhập tên hiển thị',
      displayNamePlaceholder: 'Tên hiển thị tác giả',
      slug: 'Slug (URL trang tác giả)',
      slugRequired: 'Vui lòng nhập slug',
      slugFormat: 'Slug phải là chữ thường và dấu gạch nối (kebab-case)',
      slugTaken: 'Slug này đã được sử dụng, vui lòng chọn slug khác',
      slugPlaceholder: 'vd: jomar-dela-cruz',
      jobTitle: 'Chức danh',
      jobTitleRequired: 'Vui lòng nhập chức danh',
      jobTitlePlaceholder: 'vd: Senior Content Editor',
      location: 'Địa điểm',
      expertiseTags: 'Thẻ chuyên môn (3-5, knowsAbout)',
      expertiseTagsTip: 'Nhấn enter để thêm',
      quoteHighlight: 'Trích dẫn nổi bật',
      quoteHighlightPlaceholder: 'Trích dẫn đặc trưng của tác giả (hiển thị trên trang tác giả)',
      joinedAt: 'Ngày tham gia',
      avatar: 'Ảnh đại diện (≥400px)',
      uploadAvatar: 'Tải lên',
      bio: 'Giới thiệu',
      bioPlaceholder: 'Giới thiệu tác giả',
      socials: 'Mạng xã hội (LinkedIn bắt buộc)',
      linkedinRequired: 'LinkedIn là bắt buộc, không thể xóa',
      addSocial: 'Thêm mạng xã hội',
      platform: 'Nền tảng',
      handle: 'Handle',
      url: 'URL',
      sameAs: 'sameAs',
      exclude: 'Loại trừ',
      status: 'Trạng thái',
      enabled: 'Bật',
      disabled: 'Tắt',
        editorialApproach: 'Phương châm biên tập',
    editorialApproachPlaceholder: 'Mô tả phong cách và tiêu chuẩn biên tập của tác giả',
    previewSchema: 'Xem trước Person Schema (JSON-LD)',
},
    frm: {
      displayNamePlaceholder: 'Tìm tên hiển thị',
      jobTitlePlaceholder: 'Tìm chức danh',
      statusPlaceholder: 'Chọn trạng thái',
    },
    msg: {
      createOk: 'Đã tạo',
      updateOk: 'Đã cập nhật',
      socialsSaveWarn: 'Đã lưu tác giả nhưng lưu tài khoản xã hội thất bại; vui lòng chỉnh sửa và lưu lại',
      operateFail: 'Thao tác thất bại',
      linkedinRequired: 'LinkedIn là bắt buộc (cần URL)',
      avatarFormat: 'Chỉ hỗ trợ JPG/PNG/WEBP',
      avatarMaxSize: 'Ảnh phải nhỏ hơn 2MB',
      avatarTooSmall: 'Ảnh đại diện phải ≥400×400px',
      urlInvalid: 'Vui lòng nhập URL hợp lệ (bắt đầu bằng http(s)://)',
      deleteConfirm: 'Xác nhận xóa tác giả này?',
      view: 'Xem',
        schemaSaveFirst: 'Vui lòng lưu tác giả trước khi xem trước Person Schema.',
    schemaLoadFail: 'Tải xem trước Person Schema thất bại.',
},
      infoBanner: 'Hồ sơ tác giả càng đầy đủ (chức danh + chuyên môn + LinkedIn), Person schema càng mạnh, giúp công cụ AI nhận diện tác giả là chuyên gia lĩnh vực.',
      infoBannerTitle: 'Hồ sơ tác giả ảnh hưởng đến chất lượng Person Schema',
},
  siteBaseUrl: {
    title: 'URL gốc trang H5 (h5BaseUrl)',
    declModeTip: 'Lưu trong Site Declaration (fileType=siteConfig). Lưu sẽ phát hành phiên bản mới; H5 SSR đọc giá trị mới nhất.',
    currentPublished: 'Đang phát hành',
    publishBtn: 'Lưu & Phát hành',
    publishOk: 'Đã phát hành',
    addBtn: 'Thêm cấu hình',
    notReady: 'Backend chưa sẵn sàng',
    notReadyTip: 'API cấu hình trang chưa được triển khai (không có hợp đồng Taylor). Tất cả thao tác ghi đã bị vô hiệu hóa.',
    col: {
      platform: 'Nền tảng',
      env: 'Môi trường',
      h5BaseUrl: 'H5 Base URL',
      remark: 'Ghi chú',
      updateTime: 'Thời gian cập nhật',
      action: 'Thao tác',
    },
    edit: {
      titleNew: 'Thêm cấu hình trang',
      titleEdit: 'Sửa cấu hình trang',
      platformRequired: 'Vui lòng nhập nền tảng',
      envRequired: 'Vui lòng chọn môi trường',
      envPlaceholder: 'Chọn môi trường',
      h5BaseUrlRequired: 'Vui lòng nhập H5 base URL',
      h5BaseUrlInvalid: 'Vui lòng nhập URL hợp lệ bắt đầu bằng http(s)://',
      h5BaseUrlTip: 'Không có dấu / ở cuối, ví dụ https://www.fbmplay.com',
    },
  },
};
